import React from "react";
import ReportCETCoretrade from "../ReportCETCoretrade";

const MonthlyReportCETCoretrade = () => {
  return <ReportCETCoretrade title="Monthly Report for CET and Coretrade" />;
};

export default MonthlyReportCETCoretrade;
